module.exports = __webpack_public_path__ + "static/media/Ex5-S0-SectionBreak.1acf7e32.PNG";